import { delete$, get$, handleApiError, post$, put$ } from 'services/api';
import { EntityTypeItem } from './types';

export const crudApiService = <Request, EntityType extends EntityTypeItem>(
  url: string
) => ({
  getAll: () => get$<EntityType[]>(url),
  getItem: (id: string) => get$<EntityType>(`${url}/${id}`),
  create: (body: Request) => post$<EntityType>(url, body),
  put: (body: EntityType) => put$<EntityType>(`${url}/${body.id}`, body),
  remove: (id: string) => delete$<void>(`${url}/${id}`, null),
  handleApiError: handleApiError(),
});
